import { useTranslation } from 'utils/use-translation'

import styles from './styles.module.scss'

export default function Collaborate() {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div className={styles.title}>{t('collaborate_with_us')}</div>
      <a href="mailto:marketing@coinrabbit.io">
        <div className={styles.link}>{t('marketing_email')}</div>
      </a>
    </div>
  )
}
